import React, { useEffect, useState, useRef } from "react";
// import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams,useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getProfileBasicInfo } from "../../../../services/medium";
import StarsRating from "stars-rating";
// import BookingPopUp from "./bookingpopup";
import "./profile.css";
import { deleteUserFeedbacks } from "../../../../services/admin";
import { getMediumPublicProfileDetails } from "../../../../services/uidata";
import { getPractitionarInfo } from "../../../../services/client";
import { isHTML, screenNameHandler } from "../../../../utils/helpers";
import { get } from "immutable";
import { setLoading } from "../../../../reducer/auth/auth";
import moment from 'moment';
import { toast } from "react-toastify";
import ConfirmModal from "./confirModel";
import { useTranslation } from "react-i18next";
import { el } from "date-fns/locale";
import { getMediumCoachFeedbacksList, getMediumServiceDetails } from "../../../../services/client";

const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function CoachProfileView({ onClick, show }) {
    const { t } = useTranslation("mediumProfile");
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams()
    // const dispatch = useDispatch();
    //const [profile, setProfile] = useState(null);
    const [searchParams] = useSearchParams();
    const from = searchParams.get("from");
    const serviceValue = searchParams.get("serviceValue");
    const [profileSection, setProfileSection] = useState(null);
    const [selectedService, setSelectedService] = useState("");
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState("100px");
    const [showMediumOption, setShowMediumOption] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === "setHeight") {
                let height = event.data.height + 65;
                setIframeHeight(height + "px");
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);
    //const [teachnologySection, setteachnologySection] = useState(null);
    //const [preferncesSection, setpreferncesSection] = useState(null);

    //const params = useParams();
const calledOnce = useRef(false);
    useEffect(() => {
        // dispatch(setPathArray(params.id));
        getProfile();
        // getPreferences();
        // getTechnologies();
        // return () => {
        // dispatch(setPathArray(null));
        // };
    }, []);

    const getProfile = () => {
        dispatch(setLoading(true));
        getPractitionarInfo(params.id,15)
            .then((data) => {
                setProfileSection(data.data.data);
                console.log(data.data.data.general, "medium profile data");
                let userDataInfo = data.data.data.general;
                sessionStorage.setItem("userDataInfo", JSON.stringify(userDataInfo));

                dispatch(setLoading(false));
            })
            .catch((err) => {
                console.log(err);
                dispatch(setLoading(false));
            });
    };

    // "Reviews from Mediums" pagination: get-medium-details only sends the
    // first 2 coach-review entries (coachFeedback_has_more tells us if
    // there's more), so once the profile loads we seed the list from that
    // instead of firing a second request. The "Load" button then fetches 5
    // more at a time from the dedicated paginated coach-feedbacks API.
    const LOAD_MORE_COACH_REVIEWS_LIMIT = 5;
    const [coachReviews, setCoachReviews] = useState([]);
    const [coachReviewsOffset, setCoachReviewsOffset] = useState(0);
    const [hasMoreCoachReviews, setHasMoreCoachReviews] = useState(false);
    const [loadingCoachReviews, setLoadingCoachReviews] = useState(false);
    const loadMoreRef = useRef(null);

    useEffect(() => {
        if (profileSection && profileSection.coachFeedback) {
            setCoachReviews(profileSection.coachFeedback);
            setCoachReviewsOffset(profileSection.coachFeedback.length);
            setHasMoreCoachReviews(!!profileSection.coachFeedback_has_more);
        }
    }, [profileSection]);

    const loadMoreCoachReviews = () => {
        const medium_id = profileSection && profileSection.general ? profileSection.general.medium_id : undefined;
        if (!medium_id) return;
        setLoadingCoachReviews(true);
        getMediumCoachFeedbacksList(medium_id, coachReviewsOffset, LOAD_MORE_COACH_REVIEWS_LIMIT)
            .then((data) => {
                if (data.data.status) {
                    const { coachFeedback: newFeedback, has_more, offset: returnedOffset, limit: returnedLimit } = data.data.data;
                    setCoachReviews((prev) => [...prev, ...newFeedback]);
                    setCoachReviewsOffset(returnedOffset + returnedLimit);
                    setHasMoreCoachReviews(has_more);
                }
            })
            .catch(() => { })
            .finally(() => setLoadingCoachReviews(false));
    };

    // Infinite scroll: auto-load the next page of reviews when the sentinel
    // at the bottom of the list scrolls into view (replaces the "Load" button).
    useEffect(() => {
        if (!hasMoreCoachReviews) return;
        const el = loadMoreRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loadingCoachReviews) {
                    loadMoreCoachReviews();
                }
            },
            { root: null, rootMargin: "200px", threshold: 0 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [hasMoreCoachReviews, loadingCoachReviews, coachReviewsOffset]);

    const calculateUnique = (arr) => {
        let value = arr.reduce((acc, val) => {
            acc[val] = acc[val] === undefined ? 1 : (acc[val] += 1);
            return acc;
        }, {});
        return value;
    };
    const calculateRating = (feedbacks) => {
        let total = 0;
        let sum_resp = 0;
        let counts = feedbacks.map((item) => {
            return parseInt(JSON.parse(item.feedback).Star_Rating);
        });

        Object.entries(calculateUnique(counts)).map(([key, value]) => {
            sum_resp += parseInt(value) * parseInt(key);
            total += parseInt(value);
        });
        let score = Math.round((sum_resp / total) * 2) / 2;
        return score;
        // return Math.floor(sum_resp / total);
    };
    // const getPreferences = () => {
    //     getProfilePreferences()
    //         .then((data) => {

    //             setpreferncesSection(data.data.data);
    //         })
    //         .catch((err) => console.log(err));
    // };
    // const getTechnologies = () => {
    //     getProfileTechnology()
    //         .then((data) => {
    //             setteachnologySection(data.data.data);
    //         })
    //         .catch((err) => console.log(err));
    // };
    const getBio = (info) => {
        const rawContentFromDB = info
        let html;
        if (!isHTML(rawContentFromDB)) {
            let info =
                rawContentFromDB
                    .split("\n")
                    .map(line => `${line}`)
                    .join("");
            console.log(info, "cejdncjkm");
            html = info
            return info
        }
        else {

            html = JSON.parse(rawContentFromDB).content
            return <div dangerouslySetInnerHTML={{ __html: JSON.parse(rawContentFromDB).content }} />
        }

    }
    const getInfo = (info) => {

        const rawContentFromDB = info
        let html;
        if (!isHTML(rawContentFromDB)) {
            console.log(info, "ckejdnm1")
            let info =
                rawContentFromDB
                    .split("\n")
                    .map(line => `${line}`)
                    .join("");
            console.log(info, "cejdncjkm");
            html = info
            return info
        }
        else {
            // console.log( info,"ckejdnm2")
            // html = JSON.parse(rawContentFromDB).content
            // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />

            html = JSON.parse(rawContentFromDB).content
            const srcDoc = generateSrcDoc(html);
            return srcDoc
        }

        // "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"

    }
    const formatDate = (dateStr) => {
  return moment(dateStr).format('MMM D, YYYY'); // e.g. "Sep 18, 2025"
};
  const handleGoBack = () => {
const params = new URLSearchParams(location.search);
    const page = params.get("page"); // get 'page' query value

    // if (page === "group"){
    //     sessionStorage.removeItem("bookingPageState");
    //     navigate("/go-on-demand-practice?to=groupcoaching");
    //allpracticecircles
    // } else {
        window.loadModal2("#ConfirmModalShow", "show");
    // }
    //navigate(-1); // 👈 goes back to previous page, keeps state intact
  };
  const confirmModelRequest = () => {
    console.log(selectedService, Number(params.id));
    let selectedMediumIdNumber = Number(params.id);
     const savedState = sessionStorage.getItem("bookingPageState");

    const {
      serviceValue,
      service,
      sessionLength,
      serviceType,
      sessionLengthList,
      pricingType,
      coachType,
      coachingTypeBackup,
      coachingType,
      selectedMediumId,
      serviceTypeList,
    } = JSON.parse(savedState);
   
    if(selectedService === ""){
        toast.error(t("coachView.selectService"));
        return;
    }else{
        const params = new URLSearchParams(location.search);
        const page = params.get("page"); // get 'page' query value
        const comingFrom = params.get("comingFrom");
        if (page === "group"){
            
            if(selectedService == "Group Coaching"){
                sessionStorage.removeItem("bookingPageState");
             navigate(`/go-on-demand-practice?to=${comingFrom}`);
             return;
            }
        } 
        if(selectedService == "1-on-1 Coaching"){
            let coach30Min = process.env.REACT_APP_COACHING_GROUP_SESSION_ID == 83 ? 64 : 29;
            if(sessionLength == coach30Min || sessionLength == 92){
                navigate("/booking?from=coach-reviews");
            }else{
                let data = {
                        serviceValue: 2,
                        coachType: "paid",
                        serviceType: "0",
                        selectedMediumId: selectedMediumIdNumber,
                        sessionLength: process.env.REACT_APP_COACHING_GROUP_SESSION_ID == 83 ? "64" : "29",
                        sessionLengthList: [
                        { id: Number(coach30Min), sub_session_name: "Coaching 30 Minute Session", session_type: 2, duration: "30", pricing_type: "free" },
                        { id: 92, sub_session_name: "Coaching 60 Minute Session\t", session_type: 2, duration: "60", pricing_type: "fixed" },
                    ],
                }
                setSessionvalue(data);
            }

           
        }else if(selectedService == "Group Coaching"){
             if(sessionLength == process.env.REACT_APP_COACHING_GROUP_SESSION_ID || sessionLength == 94){
                navigate("/booking?from=coach-reviews");
            }else{
             let data ={
                serviceValue: 2,
                    coachType: "",
                    serviceType: "1",
                    selectedMediumId: selectedMediumIdNumber,
                    sessionLength: process.env.REACT_APP_COACHING_GROUP_SESSION_ID,
                     sessionLengthList: [
                    { id: Number(process.env.REACT_APP_COACHING_GROUP_SESSION_ID), sub_session_name: "Group Coaching", session_type: 2, duration: "60", pricing_type: "free" },
                    { id: 94, sub_session_name: "Coached Practice Circles", session_type: 2, duration: "60", pricing_type: "fixed" },
                ],
            }
            setSessionvalue(data);
            }
        }else if(selectedService == "Mediumship Session"){
            let data ={
                    serviceValue: 7,
                    coachType: "",
                    serviceType: "1",
                    selectedMediumId: selectedMediumIdNumber,
                    sessionLength: process.env.REACT_APP_COACHING_GROUP_SESSION_ID,
                     sessionLengthList: [
                    { id: Number(process.env.REACT_APP_COACHING_GROUP_SESSION_ID), sub_session_name: "Group Coaching", session_type: 2, duration: "60", pricing_type: "free" },
                    { id: 94, sub_session_name: "Coached Practice Circles", session_type: 2, duration: "60", pricing_type: "fixed" },
                ],
            }
            setSessionvalue(data);
            navigate("/booking?from=coach-reviews");
        }
       // navigate("/booking");
    }
    //
  }
  const setSessionvalue = (data) =>{
    const pageState = {
        
        service: "Coaching Sessions",
        serviceTypeList: [
            { id: 0, name: "1 on 1" },
            { id: 1, name: "Group Session" },
        ],
        pricingType: "free",
        coachingTypeBackup: "free",
        coachingType: "paid",
        };
        const finalState = { 
            ...pageState, 
            ...data 
        };

        console.log(finalState);

        // If you want to store it or set in state/session
        sessionStorage.setItem("bookingPageState", JSON.stringify(finalState));
        navigate("/booking?from=coach-reviews");
}
    useEffect(() => {
        getMediumServiceDetails(Number(params.id))
                .then((data) => {
                if (data.data.status) {
                    if (data && data.data && data.data.data && data.data.data[0]) {
                    var responseData = data.data.data[0];

                    if (responseData.info && responseData.info.length > 0) {
                        setShowMediumOption(true);
                    } else {
                        setShowMediumOption(false);
                    }
                    }
                }
                })
                .catch(() => { });
    }, []);
    return (
        <div className="container-fluid px-2 px-md-4 py-3 schedule-advance-box-all-container">
            <div className="single-profile-saction single-profile-saction-new">
                {/* Back to Search button */}
                <div className="mb-3">
                    <button
                        onClick={() => {
                            const url = localStorage.getItem("coachListBackUrl");
                            if (url) {
                                sessionStorage.removeItem("bookingPageState");
                                navigate(url);
                            } else {
                                navigate(-1);
                            }
                        }}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "8px 18px",
                            fontSize: "15px",
                            fontWeight: "500",
                            cursor: "pointer",
                            color: "#333",
                        }}
                    >
                        &#8592; {t("coachView.backToSearch")}
                    </button>
                </div>

                {/* Profile card */}
                <div className="profile-all-box">

                    {/* Header with logo */}
                    <div className="header-container">
                        <img src="/images/Very Soul Logo Black.png" alt="Logo" className="header-logo" />
                    </div>

                    {/* Profile header row */}
                    <div className="px-3 px-md-4 pt-3">
                        <div className="row align-items-start">

                            {/* Avatar */}
                            <div className="col-auto">
                                <div className="profile-image">
                                    <img
                                        className="public-profile-picture"
                                        src={
                                            profileSection !== null && profileSection.general.profile_image !== ""
                                                ? process.env.REACT_APP_IMAGE_URL + profileSection.general.profile_image
                                                : "/images/user-dummy.png"
                                        }
                                        onError={(e) => (e.target.src = "/images/user-dummy.png")}
                                        alt="avatar"
                                    />
                                </div>
                            </div>

                            {/* Name */}
                            <div className="col" style={{ minWidth: 0 }}>
                                <div className="profile-name">
                                    <div className="nam-prof">
                                        {profileSection && profileSection.general && profileSection.general.screen_name
                                            ? profileSection.general.screen_name
                                            : screenNameHandler(
                                                profileSection && profileSection.general ? profileSection.general.first_name : "",
                                                profileSection && profileSection.general ? profileSection.general.last_name : ""
                                            )}
                                    </div>
                                    <a href="#">
                                        {profileSection && profileSection.general && profileSection.general.screen_name
                                            ? profileSection.general.screen_name
                                            : screenNameHandler(
                                                profileSection && profileSection.general ? profileSection.general.first_name : "",
                                                profileSection && profileSection.general ? profileSection.general.last_name : ""
                                            )}
                                    </a>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="col-12 col-sm-auto mt-2 mt-sm-2">
                                <div className="profile-book-now" style={{ float: 'none', width: '100%', padding: 0 }}>
                                    <a
                                        className="book-now-practice d-block text-center mb-2"
                                        style={{ padding: '10px 28px', cursor: 'pointer' }}
                                        onClick={handleGoBack}
                                    >
                                        {t("view.bookHere")}
                                    </a>
                                    <a
                                        className="public-profile d-block text-center"
                                        href={
                                            profileSection !== null && profileSection.general.medium_id !== ""
                                                ? `/public-view/${profileSection.general.medium_id}?from=booking&serviceValue=${serviceValue}`
                                                : "#"
                                        }
                                        target="_blank"
                                    >
                                        {t("coachView.publicProfile")}
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* As A Coach */}
                    {profileSection !== null && profileSection.general.as_a_coach !== "" && (
                        <div className="profile-bio px-3 px-md-4 mt-3">
                            <h2>{t("coachView.asACoach")}</h2>
                            <iframe
                                ref={iframeRef}
                                srcDoc={getInfo(profileSection.general.as_a_coach)}
                                style={{ width: '100%', height: iframeHeight, border: 'unset' }}
                                title={t("view.editorPreview")}
                            />
                        </div>
                    )}

                    {/* Languages & Country */}
                    <div className="profile-bio px-3 px-md-4">
                        <p>
                            {t("coachView.languages")}{" "}
                            {profileSection && profileSection.general && profileSection.general.languages
                                ? profileSection.general.languages.map((data) => data.lanugage_name).join(", ")
                                : ""}
                            <br />
                            {t("coachView.country")} {profileSection !== null && profileSection.general.country}
                        </p>
                    </div>

                    {/* Reviews */}
                    <div className="profile-bio px-3 px-md-4">
                        <h2 className="mb-3">{t("coachView.reviewsFromMediums")}</h2>

                        <div className="feedback-container">
                            {coachReviews.map((feedback, idx) => (
                                <div key={idx} className="feedback-border-feed row border-bottom py-3 mx-0 mt-2">
                                    <div className="col-12 col-md-4 mb-2 mb-md-0">
                                        <div className="d-flex align-items-center">
                                            <div className="feedback-image flex-shrink-0">
                                                <img
                                                    className="practioner-profile-image"
                                                    src="../images/user-dummy.png"
                                                    alt="avatar"
                                                />
                                            </div>
                                            <span className="ml-2" style={{ fontSize: '14px' }}>
                                                {feedback.name} — {feedback.country}
                                            </span>
                                        </div>
                                        <div className="feedback-star-image mt-1"></div>
                                        <p className="feedback-date mb-0">{formatDate(feedback.date)}</p>
                                    </div>
                                    <div className="col-12 col-md-8">
                                        <p className="feedback-heading mb-1">{feedback.title}</p>
                                        <p style={{ fontSize: '14px', color: '#555', marginBottom: 0 }}>{feedback.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {hasMoreCoachReviews && (
                            <div ref={loadMoreRef} style={{ height: 1 }} />
                        )}
                        {loadingCoachReviews && (
                            <div className="text-center mt-3" style={{ fontSize: "14px", color: "#555" }}>
                                {t("view.loading")}
                            </div>
                        )}
                    </div>

                </div>
            </div>

            <ConfirmModal
                deleteUser={confirmModelRequest}
                id={"ConfirmModalShow"}
                label={t("coachView.areYouSure")}
                btnLabel={t("coachView.continue")}
                selectedService={selectedService}
                setSelectedService={setSelectedService}
                showMediumOption={showMediumOption}
            />
        </div>
    );
}
